<template>
  <div class="barChart" ref="barChartContainerDiv">
    <el-table
      v-if="rerenderFlag"
      :data="items"
      class="style-fullWidth"
      highlight-current-row
      :height="chartSize.height"
    >
      <el-table-column width="40" type="index" fixed></el-table-column>

      <el-table-column width="50" align="center" fixed>
        <template slot-scope="scope">
          <div v-if="isTop(scope.row)">
            <el-tooltip
              :content="`# ${getTopInfo(scope.row).level + 1}`"
              placement="top"
            >
              <i :class="['fas fa-crown', getTopClass(scope.row)]"> </i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        property="fullName"
        label="Nhân viên"
        min-width="200"
        sortable
        show-overflow-tooltip
        align="left"
        header-align="left"
        fixed
      >
        <template slot-scope="scope">
          <a class="clickable" @click="viewDetail(scope.row)">
            <span>{{ scope.row.fullName }}</span>
          </a>
        </template>
      </el-table-column>

      <el-table-column
        property="sumOfChuyenMon"
        label="Chuyên môn"
        width="150"
        align="right"
        header-align="right"
        sortable
      >
        <template slot-scope="scope"
        >{{ formatNumber(scope.row.sumOfChuyenMon) }}
        </template>
      </el-table-column>

      <el-table-column
        property="sumOfNguyenTac"
        label="Nguyên tắc"
        width="150"
        align="right"
        header-align="right"
        sortable
      >
        <template slot-scope="scope"
        >{{ formatNumber(scope.row.sumOfNguyenTac) }}
        </template>
      </el-table-column>

      <el-table-column
        property="sum"
        label="Tổng điểm"
        width="150"
        align="right"
        header-align="right"
        sortable
      >
        <template slot-scope="scope"
        >{{ formatNumber(scope.row.sum) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ListTemplate from "../../common/list";
import MainHeader from "../../../components/header/main-header";
import SubHeader from "../../../components/main/sub-header";
import dateFormatter from "../../../filters/dateFormatter";
import h from "../../../services/h";
import numeral from "numeral";

export default {
  name: "ranking-report-common-table",
  components: {
    SubHeader,
    MainHeader,
    ListTemplate
  },

  filters: {dateFormatter},

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    }
  },

  data() {
    return {
      reportResult: null,
      items: [],
      topInfos: [],
      chartSize: {
        heigth: 100
      },
      rerenderFlag: true //trick để thực hiện render lại table
    };
  },

  watch: {
    reportResult() {
      this.populateItems();
      this.initTopInfos();
      //trick để render lại tablet;
      this.rerenderFlag = false;
      this.$nextTick(() => (this.rerenderFlag = true));
    }
  },

  mounted() {
    this.calculateChartSize();
  },

  methods: {
    renderTable(options) {
      this.reportResult = options.reportResult;
    },

    viewDetail(item) {
      this.$emit("viewDetail", {item: item});
    },

    initTopInfos() {
      this.topInfos = [];
      if (!this.items || !this.items.length) return;
      let items = this.items.slice();
      items.sort((item1, item2) => item2.sum - item1.sum);
      let level = 0;
      let levelScore = items[0].sum;
      for (let index = 0; index < items.length; index++) {
        let item = items[index];
        if (levelScore === item.sum) {
          this.topInfos.push({
            userDeptRoleId: item.userDeptRoleView.id,
            level: level
          });
        } else {
          if (level === 2) return;
          level++;
          levelScore = item.sum;
          this.topInfos.push({
            userDeptRoleId: item.userDeptRoleView.id,
            level: level
          });
        }
      }
    },

    isTop(item) {
      return !!this.getTopInfo(item);
    },

    getTopClass(item) {
      let topInfo = this.getTopInfo(item);
      if (!topInfo) return "";
      switch (topInfo.level) {
        case 0:
          return "ranking-gold";
        case 1:
          return "ranking-silver";
        case 2:
          return "ranking-bronze";
      }
    },

    getTopInfo(item) {
      return h.find(
        this.topInfos,
        topInfo => topInfo.userDeptRoleId === item.userDeptRoleView.id
      );
    },

    formatNumber(value) {
      return numeral(value).format("0.0");
    },

    populateItems() {
      this.items = h.collect(
        this.reportResult.userDeptRoleViews,
        userDeptRoleView => {
          let item = h.find(
            this.reportResult.items,
            item => item.userDeptRoleId === userDeptRoleView.id
          );
          return {
            userDeptRoleView: userDeptRoleView,
            fullName: userDeptRoleView.fullName,
            sum: item.sum + 100,
            sumOfChuyenMon: item.sumOfChuyenMon + 100,
            sumOfNguyenTac: item.sumOfNguyenTac + 100
          };
        }
      );
      this.items.sort((o1, o2) =>
        o2.sum - o1.sum !== 0
          ? o2.sum - o1.sum
          : (o1.fullName || "").localeCompare(o2.fullName || "")
      );
    },

    calculateChartSize() {
      this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
    }
  }
};
</script>

<style scoped>
.barChart {
  margin-top: 20px;
  height: calc(100% - 100px) !important;
  width: calc(100% - 10px) !important;
  position: relative;
}

.break-word {
  word-break: break-word;
}

.ranking-gold {
  color: gold;
}

.ranking-silver {
  color: silver;
}

.ranking-bronze {
  color: darkorange;
}
</style>



// WEBPACK FOOTER //
// src/views/report/ranking/ranking-report-common-table.vue